import { Menu, type MenuProps } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import type { StrictOmit } from "../../../lib/lang"

const useStyles = makeStyles()(() => ({
    paper: {
        "&.MuiMenu-paper": {
            minWidth: "11rem",
            borderRadius: ".75rem",
        },
        "& .MuiMenuItem-root + .MuiDivider-root": {
            marginTop: 0,
            marginBottom: 0,
        },
    },
}))

type Props = StrictOmit<MenuProps, "classes">

export function StandardMenu(props: Props) {
    const { classes } = useStyles()

    return <Menu {...props} classes={{ paper: classes.paper }} />
}
